<div class="container fw-b">
  <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
</div>
<div class="container mt-4 mb-5">
  <div class="product-detail-wrapper">
    <div class="row mt-3 product-details-row">
      <!-- Product Images Section -->
      <div class="col-md-7">
        <div class="product-image-gallery">
          <div class="main-image-container">
            <img class="main-product-image" [hidden]="!imageLoaded" (load)="onImageLoad()" [src]="imgurl"
              alt="Product Image">
            <ngx-skeleton-loader *ngIf="!imageLoaded" [theme]="{width: '100%',
            height: '405px',
            position: 'relative'}" count="1"></ngx-skeleton-loader>
          </div>
          <div class="thumbnail-gallery" *ngIf="productDetails?.dealImage?.length > 1">
            <div class="thumbnail-item" *ngFor="let item of productDetails?.dealImage; let i = index"
              [class.active]="imgurl === item" (click)="changeProductimage(item)">
              <img class="thumbnail-image" [src]="item" alt="Product thumbnail">
            </div>
          </div>
        </div>
      </div>

      <!-- Product Details Section -->
      <div class="col-md-5">
        <div class="product-details-section">
          <!-- Shimmer Loader for Product Title -->
          <ngx-skeleton-loader *ngIf="!isLoading" [theme]="{
            width: '90%',
            height: '32px',
            'border-radius': '8px',
            'margin-bottom': '15px'
          }"></ngx-skeleton-loader>
          
          <!-- Product Title with Preferred Price -->
          <div class="d-flex justify-content-between align-items-start mb-3" *ngIf="isLoading">
            <h1 class="prdct-home mb-0" style="flex: 1;">{{ productDetails?.dealName }}</h1>
            <div class="preferred-price-container" *ngIf="!intrestedPrice">
              <button
                class="btn btn-theme int"
                [disabled]="intrestedPrice"
                (click)="openModal()">
                Preferred Price
              </button>
              <span class="info">
                <img src="./../../../../assets/svg/info.svg" alt="info icon" />
              </span>
            </div>
          </div>

          <!-- Product ID -->
          <p class="para-text-common mb-3" *ngIf="isLoading">
            Product ID: {{ productDetails?._id | slice : 0 : 7 }}
          </p>

          <!-- Description Section -->
          <div class="description-section" *ngIf="isLoading && productDetails?.description">
            <h3 class="desc mb-2">Description</h3>
            <p class="descrip" [class.description-collapsed]="!isDescriptionExpanded" [innerHTML]="getRawText(productDetails?.description)"></p>
            <button class="read-more-btn" *ngIf="productDetails?.description?.length > 150" (click)="isDescriptionExpanded = !isDescriptionExpanded">
              {{ isDescriptionExpanded ? 'Read Less' : 'Read More' }}
            </button>
          </div>

          <!-- Pricing Section -->
          <ngx-skeleton-loader *ngIf="!isLoading" [theme]="{
            width: '150px',
            height: '40px',
            'border-radius': '8px',
            'margin-bottom': '10px'
          }"></ngx-skeleton-loader>
          
          <div class="pricing-section" *ngIf="isLoading">
            <!-- Without Campaign -->
            <ng-container *ngIf="!isCampaignActive()">
              <div class="original-price" *ngIf="productDetails?.dealDiscount">
                {{ mrp ? getPrice(mrp | currency : "ZAR" : "R") : getPrice(productDetails?.dealDetails[0]?.price | currency : "ZAR" : "R") }}
              </div>
              <div class="current-price">
                {{ afterDiscountPrice && productDetails?.dealDiscount ? getPrice(afterDiscountPrice | currency : "ZAR" : "R") : (mrp ? getPrice(mrp | currency : "ZAR" : "R") : getPrice(productDetails?.dealDetails[0]?.price | currency : "ZAR" : "R")) }}
              </div>
              <div class="discount-badge" *ngIf="productDetails?.dealDiscount">
                {{ productDetails?.dealDiscount }}% OFF
              </div>
            </ng-container>

            <!-- With Campaign -->
            <ng-container *ngIf="isCampaignActive()">
              <div class="original-price">
                {{ mrp ? getPrice(mrp | currency : "ZAR" : "R") : getPrice(productDetails?.dealDetails[0]?.price | currency : "ZAR" : "R") }}
              </div>
              <div class="current-price">
                {{ getcampaignDiscountedPrice()?.discountedPrice ? getPrice(getcampaignDiscountedPrice()?.discountedPrice | currency : "ZAR" : "R") : getPrice(getcampaignDiscountedPrice()?.discountedPrice | currency : "ZAR" : "R") }}
              </div>
              <div class="discount-badge">
                {{ getcampaignDiscountedPrice()?.discountedPercentage }}% OFF
              </div>
            </ng-container>
          </div>

          <!-- Campaign Timer -->
          <div class="d-flex align-items-center mb-3" *ngIf="isLoading && isCampaignActive()">
            <label style="font-weight: 600; color: #1f1f27; margin-right: 8px; margin-bottom: 0; font-family: 'Noto Sans', sans-serif;">Campaign Ends In:</label>
            <div class="timer-container">
              <span class="countdown-timer">{{getCountDownTime(productDetails?.campainId?.endDate) || '00D:00H:00M:00S'}}</span>
            </div>
          </div>

          <!-- Product Meta Info -->
          <div class="product-meta mb-3" *ngIf="isLoading">
            <p class="pid mb-2"><strong>Product Name:</strong> {{ productDetails?.productId[0]?.productName }}</p>
            <p class="pid mb-2"><strong>Category:</strong> {{ productDetails?.productId[0]?.categoryId?.categoryName }}</p>
          </div>

          <!-- Size Selection -->
          <div class="size-label-and-row" *ngIf="isLoading && productDetails?.productId[0]?.priceSizeDetails?.length">
            <span class="size-label">Size / Value:</span>
            <div class="size-circle-row">
              <button
                type="button"
                class="size-circle"
                *ngFor="let item of productDetails?.productId[0].priceSizeDetails"
                (click)="price(item?.price, item?.quantity, item?.value, item?.id, item?.unit)"
                [class.size-circle--active]="value == item?.value"
                [class.size-circle--disabled]="!item?.quantity"
                [disabled]="!item?.quantity">
                {{ item?.value }} {{ item?.unit !== 'other' ? item?.unit : '' }}
              </button>
            </div>
          </div>

          <!-- Stock Status and Quantity Selector -->
          <ngx-skeleton-loader *ngIf="!isLoading" [theme]="{
            width: '120px',
            height: '48px',
            'border-radius': '8px',
            'margin-bottom': '10px'
          }"></ngx-skeleton-loader>
          
          <div class="quantity-and-actions-row" *ngIf="isLoading">
            <div class="quantity-wrapper">
              <div class="stock-status" *ngIf="quantity > 0">
                <span class="stock-dot"></span>
                <span class="stock-text">In Stock ({{ quantity }} available)</span>
              </div>
              <div class="stock-status" *ngIf="quantity == 0" style="color: #dc2626;">
                <span class="stock-dot" style="background: #dc2626;"></span>
                <span class="stock-text">Out of Stock</span>
              </div>
              <label class="quantity-label">Quantity:</label>
              <div class="quantity-selector">
                <button type="button" class="quantity-btn" (click)="decreaseQuantity()">
                  <i class="fa fa-minus" aria-hidden="true"></i>
                </button>
                <input type="number" class="quantity-input" [(ngModel)]="selectedQuantity" min="1"
                  [max]="quantity || 999" readonly>
                <button type="button" class="quantity-btn" (click)="increaseQuantity()">
                  <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <!-- Add to Cart Button (guest + logged-in) -->
            <button class="add-to-cart-btn" *ngIf="quantity > 0 && flag" (click)="addToCart()">
              <i class="fa fa-shopping-cart"></i>
              Add to Cart
            </button>
            <button class="add-to-cart-btn" *ngIf="quantity > 0 && !flag" disabled>
              Loading...
            </button>
            <button class="add-to-cart-btn" *ngIf="quantity == 0" disabled>
              Out of Stock
            </button>

            <!-- Wishlist Button -->
            <button class="wishlist-action-btn" *ngIf="isLoggedIn" (click)="addWishlist(productDetails?._id)">
              <i class="fa fa-heart-o" *ngIf="productDetails?.isLike == false"></i>
              <i class="fa fa-heart" *ngIf="productDetails?.isLike == true"></i>
              Wishlist
            </button>
            <button class="wishlist-action-btn" *ngIf="!isLoggedIn" (click)="showMessage()" [routerLink]="['/login']">
              <i class="fa fa-heart-o"></i>
              Wishlist
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<div class="modal fade" id="interestedPriceModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modern-modal-dialog" role="document">
    <div class="modal-content modern-modal-content">
      <div class="modern-modal-header">
        <div class="modal-header-content">
          <h2 class="modern-modal-title">Submit Your Preferred Price</h2>
          <p class="modern-modal-subtitle">Make an offer and the retailer will review your proposal</p>
        </div>
        <button type="button" class="modern-close-btn" data-dismiss="modal" aria-label="Close">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modern-modal-body">
        <div class="form" *ngIf="showInterestedPriceModal">
          <!-- Product Preview Section with Size and Price -->
          <div class="modal-product-section">
            <div class="modal-product-left">
              <img class="modal-product-image" [src]="productDetails?.dealImage[0]" alt="Product Image" />
            </div>
            <div class="modal-product-right">
              <!-- Size/Value Selection -->
              <div class="modal-form-group-compact">
                <label class="modal-label">Size / Value</label>
                <div class="modal-size-options">
                  <button
                    type="button"
                    class="modal-size-btn"
                    *ngFor="let item of productDetails?.productId[0].priceSizeDetails"
                    (click)="price(item?.weight, item?.volume, item?.price, item?.quantity, item?.value, item?.id, item?.unit)"
                    [class.modal-size-btn-active]="value == item?.value">
                    {{ item?.value }} {{ item?.unit !== 'other' ? item?.unit : '' }}
                  </button>
                </div>
              </div>

              <!-- Current Price Display -->
              <div class="modal-form-group-compact">
                <label class="modal-label">Current Price</label>
                <div class="modal-current-price">
                  {{ mrp ? getPrice(mrp | currency : "ZAR" : "R") : getPrice(productDetails?.priceSizeDetails[0]?.price | currency : "ZAR" : "R") }}
                </div>
              </div>
            </div>
          </div>

          <!-- Preferred Price Input -->
          <div class="modal-form-group">
            <label class="modal-label" for="preferredPriceInput">Your Preferred Price</label>
            <div class="modal-input-wrapper">
              <span class="currency-symbol">R</span>
              <input
                type="text"
                id="preferredPriceInput"
                class="modal-input"
                [(ngModel)]="interestedPrice"
                placeholder="Enter your price"
                aria-describedby="priceHelp">
            </div>
            <small class="modal-error-text" *ngIf="mrp < interestedPrice">
              <i class="fa fa-exclamation-circle"></i> Price cannot exceed current price
            </small>
          </div>

          <!-- Quantity Selection -->
          <div class="modal-form-group">
            <label class="modal-label" for="quantitySelect">Quantity</label>
            <select id="quantitySelect" class="modal-select" [(ngModel)]="intrestedQuantity">
              <option value="" disabled>Select Quantity</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
            </select>
          </div>

          <!-- Purchase Preference -->
          <div class="modal-form-group">
            <label class="modal-label">Purchase Preference</label>
            <div class="modal-radio-group">
              <label class="modal-radio-option" for="auto-spordaic">
                <input
                  type="radio"
                  (change)="spordicType = 'AUTOMATIC'"
                  name="spordaicSelection"
                  id="auto-spordaic"
                  [checked]="spordicType === 'AUTOMATIC'">
                <span class="modal-radio-content">
                  <span class="modal-radio-title">Automatic</span>
                  <span class="modal-radio-desc">Buy automatically when campaign starts</span>
                </span>
              </label>
              <label class="modal-radio-option" for="semi-spordaic">
                <input
                  type="radio"
                  (change)="spordicType = 'SEMIAUTOMATIC'"
                  name="spordaicSelection"
                  id="semi-spordaic"
                  [checked]="spordicType === 'SEMIAUTOMATIC'">
                <span class="modal-radio-content">
                  <span class="modal-radio-title">Semi-Automatic</span>
                  <span class="modal-radio-desc">Review cart before purchase</span>
                </span>
              </label>
              <label class="modal-radio-option" for="manual">
                <input
                  type="radio"
                  (change)="spordicType = 'MANUAL'"
                  name="spordaicSelection"
                  id="manual"
                  [checked]="spordicType === 'MANUAL'">
                <span class="modal-radio-content">
                  <span class="modal-radio-title">Manual</span>
                  <span class="modal-radio-desc">Receive notification when campaign starts</span>
                </span>
              </label>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="modal-footer-actions">
            <button
              class="modern-confirm-btn"
              (click)="confirmInterestedPrice()"
              [disabled]="mrp < interestedPrice || !interestedPrice || !intrestedQuantity">
              <i class="fa fa-check-circle"></i>
              Confirm Preferred Price
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div class="modal fade" id="interestedPriceModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="margin-top: 230px;">
      <div class="modal-header" style="height: 90px; background: #BF1E2E;">
        <h5 class="modal-title" id="exampleModalLabel" style="width: 135px; height:60px"><img
            style="height: 100%; width:100%; object-fit: cover;" src="assets/img/whiteLogo.png" alt=""></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">

        </button>
      </div>
      <div class="modal-body">
        <div class="form" *ngIf="showInterestedPriceModal">

          <div class="row justify-content-between">
            <div class="col-md-12 text-center">
             
              <img
                class="custom-img h-100 change-img"
                style="cursor: pointer; height: 200px !important;"
                [src]="productDetails?.dealImage[0]"
               
              />
          
            </div>
           
            <div class="col-md-12 text-center">
              <div class="form-group d-flex">
                <label for="size">Size/Value :- </label>
                <ng-container *ngFor="let item of productDetails?.productId[0].priceSizeDetails">
                  <p class="pid-1 new-loop-para"
                    (click)="price(item?.price, item?.quantity, item?.value, item?.id, item?.unit)"
                    [ngClass]="{ active: value == item?.value }">
                    {{ item?.value }} {{ item?.unit !== 'other' ? '' + item?.unit : '' }}
                  </p>
                </ng-container>
              </div>
            </div>

            <div class="col-6 dealpaddingBox mt-3">
              <div class="row justify-content-between">
                <div>Price :-</div>
                <span>
                  {{
                    mrp
                      ? getPrice(mrp | currency : "ZAR" : "R")
                      : mrp &&
                        getPrice(
                          productDetails?.dealDetails[0]?.price
                            | currency : "ZAR" : "R"
                        )
                  }}
                </span>
              </div>
            </div>
            <div class="col-md-6 text-center">
             
              <div class="form-group">
                <label for="exampleInputEmail1">Interested Price</label>
                <input type="text" class="form-control" [(ngModel)]="interestedPriceModal" aria-describedby="toDate"
                  placeholder="Enter Interested Price"
                  (keypress)="commonService.numberOnly($event)"
                  (keypress)="commonService.preventSpace($event);commonService.numberOnly($event)"
                  (keyup)="limitInterestedPrice()">
              </div>
            </div>
         
            <div class="col-md-12 text-center">
              <button class="btn btn-theme" (click)="confirmInterestedPrice()">Confirm Price</button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->